import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './containers/main/main.component';
import { ApiService } from './services/api.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared';
import { StoreModule } from '@ngrx/store';
import { reducers, EcomEffects } from './store';
import { EffectsModule } from '@ngrx/effects';
import { EditWebsiteComponent } from './containers/edit-website/edit-website.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [MainComponent, EditWebsiteComponent],
  providers: [ApiService],
  imports: [
    CommonModule,
    NgbModule,
    SharedModule,
    NgbModule,
    StoreModule.forFeature('Ecom', reducers),
    EffectsModule.forFeature([EcomEffects]),
    ReactiveFormsModule,
  ],
})
export class EcomModule {}
